import React from "react";

const Hero = () => {
  return (
    <section id="home" className="relative bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 py-32">
      <div className="container mx-auto text-center px-4">
        <h1 className="text-5xl md:text-6xl font-bold mb-4">
          Satwik Tripathi
        </h1>
        <p className="text-xl md:text-2xl mb-6">
          Data Engineer | Python | SQL | ETL Pipelines | Data Analytics
        </p>
        <div className="flex justify-center gap-4 flex-wrap mb-6">
          <a
            href="https://github.com/tripathisatwik"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-3 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/tripathisatwik/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-3 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 font-semibold hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            LinkedIn
          </a>
        </div>
        <div className="flex justify-center gap-4 flex-wrap">
          <a
            href="/SatwikTripathiResume.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 border-2 border-gray-900 dark:border-gray-100 rounded-full font-semibold hover:bg-gray-200 dark:hover:bg-gray-700 transition"
          >
            View CV
          </a>
          <a
            href="/SatwikTripathiResume.pdf"
            download
            className="px-6 py-3 border-2 border-gray-900 dark:border-gray-100 rounded-full font-semibold hover:bg-gray-200 dark:hover:bg-gray-700 transition"
          >
            Download CV
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;